// LanguagePicker.tsx — widget del step 'language'.
// Qué hace: grilla de idiomas (bandera + label) para el contenido del post.
// Qué exporta: LanguagePicker.
// Quién lo usa: NovahGenerateChat.

import { LANGUAGE_OPTIONS } from '../types';
import { WidgetWrap, StyleGrid, StyleOption, StyleIcon, StyleLabel } from '../styled';

interface Props {
  confirmLanguage: (lang: string) => void;
}

export function LanguagePicker({ confirmLanguage }: Props) {
  return (
    <WidgetWrap>
      <StyleGrid>
        {LANGUAGE_OPTIONS.map((opt) => (
          <StyleOption key={opt.id} $active={false} onClick={() => confirmLanguage(opt.id)}>
            <StyleIcon>{opt.flag}</StyleIcon>
            <StyleLabel>{opt.label}</StyleLabel>
          </StyleOption>
        ))}
      </StyleGrid>
    </WidgetWrap>
  );
}
